module.exports = __webpack_public_path__ + "img/title-icon.e3e94092.png";